import React from 'react';
import cn from 'classnames';
import { Spinner } from 'src/components/animations/Spinner';
import styles from './Preloader.module.css';
import PreloadIcon from '../../images/loader.svg?url';

interface Props {
  className?: string;
  throbber?: boolean;
}

/**
 * Компонент для отображения прелоадера
 * если передан `throbber`, отображается спиннер
 * или выводится анимированный лоадер ЛТ с солнцем
 */
export const Preloader = (props: Props) => {
  const { className, throbber } = props;

  if (throbber) {
    return <Spinner className={className} />;
  }

  return (
    <div className={cn(styles.preloaderSize, className)}>
      <img src={PreloadIcon} alt="" />
    </div>
  );
};
